import { Helmet } from 'react-helmet-async';
import FeatureMasterListView from 'src/sections/feature-master/FeatureMasterListView';

export default function FeatureMasterPage() {
    return (
        <>
            <Helmet>
                <title> Dashboard: Feature Master</title>
            </Helmet>

            <FeatureMasterListView />
        </>
    );
}
